import { useSyncExternalStore } from 'react'
import { store } from './eip6963store'

export const useEIP6963Providers = () => useSyncExternalStore(store.subscribe, store.value, store.value)
